module.exports = __webpack_public_path__ + "static/media/remove.a5df39f7.svg";